import { Box, type BoxProps } from "@tokenterminal/ui/Box"
import { Card } from "@tokenterminal/ui/Card/Card"
import { Divider } from "@tokenterminal/ui/Divider"
import { Row } from "@tokenterminal/ui/Row"
import { Stack } from "@tokenterminal/ui/Stack"
import { type ReactNode } from "react"
import { WidgetContent } from "./WidgetUtils"

export function Widget({
  children,
  header,
  spacing = "4x",
  border = true,
  padding = "4x",
  ...props
}: {
  padding?: BoxProps["padding"]
  spacing?: BoxProps["padding"]
  children: ReactNode
  header: ReactNode
  border?: boolean
} & Omit<BoxProps, "padding" | "gap" | "border">) {
  const Component = border ? Card : Box

  return (
    <Component
      gap={spacing}
      flexGrow={1}
      overflow="hidden"
      {...props}
      padding="0"
      height="100%"
    >
      <Stack gap={spacing} height="100%">
        {header ? (
          <Row
            gap={spacing}
            as="header"
            paddingX={padding}
            paddingTop={padding}
          >
            {header}
          </Row>
        ) : null}
        {header ? <Divider variant="secondary" /> : null}
        <WidgetContent spacing={spacing}>{children}</WidgetContent>
      </Stack>
    </Component>
  )
}
